// extracted by mini-css-extract-plugin
export var card = "_ar-0";
export var expandedCard = "_ar-2";
export var paginated = "_ar-1";